/* import __COLOCATED_TEMPLATE__ from './manage-shared-links-menu-item.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
import templateOnlyComponent from '@ember/component/template-only';

interface ManageSharedLinksMenuItemSignature {
  Args: {};
  Blocks: {};
  Element: null;
}

const ManageSharedLinksMenuItemComponent =
  templateOnlyComponent<ManageSharedLinksMenuItemSignature>();

export default ManageSharedLinksMenuItemComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'reporting/nav-submenu-components/manage-shared-links-menu-item': typeof ManageSharedLinksMenuItemComponent;
  }
}
